"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initAndBind = initAndBind;
exports.setCurrentClient = setCurrentClient;

var _currentScopes = require("./currentScopes.js");

var _debugBuild = require("./debug-build.js");

var _logger = require("./utils-hoist/logger.js");

/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
  if (options.debug === true) {
    if (_debugBuild.DEBUG_BUILD) {
      _logger.logger.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      (0, _logger.consoleSandbox)(() => {
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
      });
    }
  }

  const scope = (0, _currentScopes.getCurrentScope)();
  scope.update(options.initialScope);
  const client = new clientClass(options);
  setCurrentClient(client);
  client.init();
  return client;
}
/**
 * Make the given client the current client.
 */


function setCurrentClient(client) {
  (0, _currentScopes.getCurrentScope)().setClient(client);
}